/**
 * @desc Intro guide
 * @example <intro></intro>
 */
(function () {
  'use strict';
  angular.
  module('gplans.dashboard').
  directive('intro', intro);

  function intro() {
    var directive = {
      templateUrl: 'templates/dashboard/intro.directive.html',
      restrict: 'E',
      scope: {
        introInit: '=',
        introExit: '=' },

      controller: IntroController,
      controllerAs: 'vm',
      bindToController: true };

    return directive;
  }

  IntroController.$inject = ['$scope', '$timeout', 'Profile', '$rootScope', 'Authentication', '$analytics', 'TempCheckin', 'UserService'];

  function IntroController($scope, $timeout, Profile, $rootScope, Authentication, $analytics, TempCheckin, UserService) {
    var vm = this;
    vm.introInit = false;
    vm.slideIndex = -1;
    vm.exitIntro = exitIntro;
    vm.getSlideIndexNext = getSlideIndexNext;
    vm.getSlideIndexPrev = getSlideIndexPrev;
    vm.getSlideIndexPage = getSlideIndexPage;
    vm.introExit = false;

    var slider;

    vm.slides = [
    {
      slideBg: 'transparent',
      title: '<div class="intro-thumb"><img src="images/intro/thumb.png"></div>',
      html: '<p class="intro-title-welcome">Welcome To G-Plans!</p>' +
      '<p class="intro-text-welcome">“I personally want to welcome you to this amazing program. ' +
      'This is the first step to a healthier happier you! <br> <b>Let’s get going!</b>”</p>' },

    {
      slideBg: 'url(images/intro/bg-1.jpg) no-repeat left top / cover',
      title: '<p class="intro-title">Custom Nutrition Program</p>',
      html: '<p class="intro-text">Your meal plan is set up for you on your custom dashboard. ' +
      '<b class="text-hotsun">Everything about your plan is custom to you.</b> ' +
      'The portion sizes, calories even macros and these will change and shift from week to week.</p>' },

    {
      slideBg: 'url(images/intro/bg-2.jpg) no-repeat left top / cover',
      title: '<p class="intro-title">Trust Your Meal Plan!</p>',
      html: '<p class="intro-text"><b>See foods that you typically <br>wouldn’t eat? Carbs? Sugars?</b></p>' +
      '<p class="intro-text">These foods and exact food amounts have been specifically picked to turn up the eat of your metabolism. ' +
      'They are all in place for a reason and If you trust your meal plan you will see amazing results!</p>' },

    {
      slideBg: 'url(images/intro/bg-3.jpg) no-repeat left top / cover',
      title: '<p class="intro-title">7-Day Meal Plans</p>',
      html: '<p class="intro-text"><b>Each meal plan is designed by Dr. Goglia in 7 day increments.</b> ' +
      'You\'ll be prompted to check in <b class="text-hotsun">after 7 days and will receive a new plan</b> based on your results.</p>' },

    {
      slideBg: 'url(images/intro/bg-4.jpg) no-repeat left top / cover',
      title: '<p class="intro-title">It’s ok if you fall off!</p>',
      html: '<p class="intro-text"><b>It happens</b> simply pick up where you left off with your plan and the weekly assessments ' +
      '<b class="text-hotsun">will automatically adapt </b>to your nutritional needs.' +
      'New plans are created every week based on your progress from the prior weeks assessment.</p>' },

    {
      slideBg: 'url(images/intro/bg-5.jpg) no-repeat left top / cover',
      title: '<p class="intro-title">Message from Dr. Goglia</p>',
      html: '',
      video: true },

    {
      slideBg: 'url(images/intro/bg-6.jpg) no-repeat left top / cover',
      title: '<p class="intro-title">Choose your start date</p>',
      html: '<p class="intro-text">Pick your start date and <b class="text-hotsun">take your time to ease into the program,</b> go shopping, ' +
      'practice drinking more water or incorporate snacks into your day and when you\'re ready get started and partner with me</p>' },

    {
      slideBg: 'white',
      html: '<p class="intro-title">Ready to see your G-Plans Dashboard?</p>' +
      '<p class="intro-text">Take a tour of your dashboard. See this weeks meals and have a look around!.</p>' }];



    function startIntro() {
      jQuery('body').addClass('ui-intro');
    }

    $scope.$watch('vm.introInit', function (newV, oldV) {
      if (newV === true) {
        $timeout(sliderInit, 500);
      }
    });

    function sliderInit() {
      slider = jQuery('.slider-intro').bxSlider({
        slideWidth: 325,
        minSlides: 1,
        maxSlides: 1,
        controls: false,
        nextText: '',
        prevText: '',
        pagerCustom: '.slider-intro__pager',
        infiniteLoop: false,
        oneToOneTouch: false,
        onSliderLoad: function onSliderLoad(currentIndex) {
          vm.slideIndex = 0;
          startIntro();
          jQuery('.slider-intro .slide').eq(currentIndex).addClass('init');
          jQuery('.slider-intro .slide').eq(vm.slides.length - 1).addClass('slide-end');
          jQuery('.slider-intro .slide').eq(6).addClass('s-date');
          jQuery('.overlay-intro .bx-viewport').addClass('bxs-' + vm.slideIndex);
          activateDatepicker();
        },
        onSlideBefore: function onSlideBefore($slideElement, oldIndex, newIndex) {
          jQuery('.overlay-intro .bx-viewport').removeClass(function (index, className) {
            return (className.match(/(^|\s)bxs-\S+/g) || []).join(' ');
          });
          jQuery('.slider-intro .slide').removeClass('show');
          jQuery('.slider-intro .slide').eq(oldIndex).addClass('showed');
          jQuery('.overlay-intro .bx-viewport').addClass('bxs-' + newIndex);
          jQuery($slideElement).addClass('show');
          if (newIndex === 5) {
            jQuery('.overlay-intro .wistia_responsive_padding').removeClass('ng-hide');
          } else {
            jQuery('.overlay-intro .wistia_responsive_padding').addClass('ng-hide');
          }
          if (newIndex > 6) {
            checkNewDate();
          }

        } });

    }

    function getSlideIndexNext(e) {
      $timeout(function () {
        jQuery('.overlay-intro__fake-overlay').hide();
      }, 500);
      jQuery('.overlay-intro__fake-overlay').show();
      slider.goToNextSlide();
      if (vm.slideIndex === -1) {
        vm.slideIndex = 0;
      } else {
        vm.slideIndex = slider.getCurrentSlide();
      }
    }

    function getSlideIndexPrev() {
      $timeout(function () {
        jQuery('.overlay-intro__fake-overlay').hide();
      }, 500);
      jQuery('.overlay-intro__fake-overlay').show();
      vm.slideIndex = slider.getCurrentSlide() - 1;
      slider.goToPrevSlide();
    }

    function getSlideIndexPage(index) {
      vm.slideIndex = index;
    }

    function activateDatepicker() {
      $timeout(function () {
        jQuery('.startDate').datepicker({
          startDate: new Date(),
          autoclose: true,
          todayHighlight: true,
          todayBtn: "linked",
          date: new Date() });

        if (!vm.start_date) $('.startDate').datepicker('setDate', new Date());
        $('.input-group.date span').click(function () {
          $(".slide.show .startDate").focus();
        });
      }, 100);
    }

    function getTodayInFormat() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today_in_string = mm + '/' + dd + '/' + yyyy;
      return today_in_string;
    }

    function checkNewDate() {
      var today_in_string = getTodayInFormat();
      if (vm.start_date != today_in_string) {
        // TODO: reset checkin!
        // reset checkin if we're not on day 1
        if (UserService.data.last_checkin.day != 1) {
          var oCheckin = {
            weight: UserService.data.current_weight,
            hips: UserService.data.last_checkin.hips,
            waist: UserService.data.last_checkin.waist,
            prior_week_success: 0 };

          TempCheckin.createCheckin(oCheckin);
        }

        // we both create and update since we don't have createOrUpdate
        // TODO: createOrUpdate – in 1 api request, http://stackoverflow.com/questions/37833307/django-rest-framework-post-update-if-existing-or-create
        Profile.updateMisc({ key: 'mealPlanPaused', value: UserService.data.last_checkin.day }).
        then(pauseSuccessFn,
        function (err) {
          console.log(err);
          Profile.createMisc({ key: 'mealPlanPaused', value: UserService.data.last_checkin.day }).
          then(pauseSuccessFn, pauseErrorFn);
        });
      }
    }

    function pauseSuccessFn(res) {
      $rootScope.mealPlanPaused = res.data.value > 0;
      $rootScope.mealPlanStartDate = vm.start_date;
      Profile.createMisc({ key: 'mealPlanStartDate', value: vm.start_date }).then(
      function (res) {},
      function (err) {
        Profile.updateMisc({ key: 'mealPlanStartDate', value: vm.start_date });
      });
      $analytics.eventTrack('Pause Plan');
    }

    function pauseErrorFn(err) {
      console.log(err);
    }

    function exitIntro() {
      vm.introInit = false;
      vm.introExit = true;
      Profile.createMisc({ key: 'starterGuideSeen', value: '1' });
      jQuery('body').removeClass('ui-intro');
    }
  }

})();